import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";

const RenewUser = () => {
  const history = useHistory();
  const location = useLocation();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    // 1) token must be present
    if (!token) {
      swal("Error", "Token missing.", "error");
      history.push("/");
      return;
    }

    // 2) check login
    const authToken = localStorage.getItem("auth_token");
    if (!authToken) {
      // save token and redirect to login
      localStorage.setItem("renew_user_token", token);
      history.push("/login");
      return;
    }

    // 3) logged in -> call renew API
    const renew = async () => {
      try {
        setLoading(true);

        // attach bearer token (if your API needs auth)
        axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;

        const res = await axios.post("/api/user/renew", { token });

        if (res.data.success) {
          swal("Success", res.data.message || "Renew successful", "success");
        } else {
          swal("Error", res.data.message || "Renew failed", "error");
        }

        // cleanup
        localStorage.removeItem("renew_user_token");

        // redirect after success (optional)
        history.push("/");
      } catch (err) {
        swal(
          "Error",
          err?.response?.data?.message || "Renew failed",
          "error"
        );
      } finally {
        setLoading(false);
      }
    };

    renew();
  }, [history, location.search]);

  return (
    <div style={{ padding: 20 }}>
      {loading ? <h3>Processing renew...</h3> : <h3>Done</h3>}
    </div>
  );
};

export default RenewUser;
